export class UserInfoModel {
    public password?: string;
    public userId?: string;
    public segUserId?: number;
    public userName?: string;
    public userTypeId?: number;
    public userType?: string;
    public role?: string;
    public employeeId?: string;
    public employeeName?: string;
    public supervisorId?: string;
    public supervisorName?: string;
    public managerId?: string;
    public managerName?: string;
    public officeId?: string;
    public officeDescription?: string;
    public listMenu?: Array<any>

    public applicationId?:number;
}